export default __webpack_public_path__ + "static/media/logo.5270025d.png";